<div
    class="agpr-top-posts-chart-container"
>
    <h5
        *ngIf="header"
        class="agpr-top-posts-chart-heading"
    >
        {{ header | titlecase }}
    </h5>

    <ng-container *ngIf="data?.length; else emptyContainer">
        <div class="agpr-topPosts-mentions">
            <ul
                [id]="id + '_mentionList'"
            >
                <li
                    *ngFor="let mention of data; index as i"
                >
                    <agpr-post-feed-card
                        [id]="id + '_socialPostFeedCard_' + i"
                        [mention]="mention"
                        [preview]="preview"
                    >
                    </agpr-post-feed-card>
                </li>
            </ul>
            <div *ngIf="data && data.length === 0"
                class="agpr-topPosts-noContent"
            >
                <agpr-message
                    [severity]="messageSeverities.noContent"
                    [style]="agprComponentStyle.social"
                >
                    {{ 'Reports.topPosts.noPosts' }}
                </agpr-message>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #emptyContainer>
    <agpr-message
        [severity]="messageSeverities.noContent"
        [style]="agprComponentStyle.social"
    >
        {{ 'Common.noContentToDisplay' | localize }}
    </agpr-message>
</ng-template>

